<template>
  <div>
    <special v-if="identificationInfo.japanSpecialZone" :identificationInfo="identificationInfo"  @getList="getList"></special>
    <normal v-else :identificationInfo="identificationInfo" @getList="getList"></normal>
  </div>
</template>

<script>
import { list } from '@/api/identification'
import normal from './normalIndex.vue'
import special from './specialIndex.vue'

export default {
  components: { special, normal },
  data () {
    return {
      info: {},
      identificationInfo: {},
    }
  },
  created () {
    this.info = this.$cookie.getCustomerInfo()
    if (!this.info) {
      this.$router.push({ path: `/identification/${this.$route.params.openOrderId}` })
      return
    }
    if (this.info.openId !== this.$route.params.openOrderId) {
      console.log(this.info.openId !== this.$route.params.openOrderId)
      this.$router.push({ path: `/identification/${this.$route.params.openOrderId}` })
      return
    }
    this.getList()
  },
  methods: {
    getList () {
      list({ token: this.info.token }).then(res => {
        if (res.errCode === '200') {
          if (!res.data) {
            // 如果token过期将cookie清空
            this.$cookie.setCustomerInfo(res.data || {})
            this.$router.push({ path: `/identification/${this.$route.params.openOrderId}` })
          }
          this.identificationInfo = res.data
        }
      })
    },
  },
}
</script>
